/**
 * Grafik omzet + customer — HANYA Owner (permintaan Owner 31 Agustus 2026).
 *
 * ⛔ SVG TANGAN, NOL PUSTAKA GRAFIK. Menambah recharts/chart.js untuk dua
 * batang berarti menambah ~100 KB ke bundle yang dimuat SETIAP orang di
 * SETIAP halaman, demi satu komponen yang cuma Owner lihat. Dua batang dan
 * satu garis nol butuh mesin grafik.
 *
 * ---------------------------------------------------------------------------
 * ⛔ TIGA HAL YANG MUDAH DIBUAT BOHONG OLEH GRAFIK
 * ---------------------------------------------------------------------------
 *
 *  1. **Bulan kosong tetap tampil.** Grafik yang melewatkan bulan nol
 *     menyambungkan dua titik berjauhan jadi satu garis landai — dan bulan
 *     yang jeblok terlihat seperti bulan biasa.
 *
 *  2. **Sumbu mulai dari NOL.** Sumbu yang dipotong membuat selisih 3% terlihat
 *     seperti selisih 300%. Itu bukan penekanan, itu kebohongan bergambar.
 *
 *  3. **Angkanya ditulis, bukan cuma digambar.** Batang tanpa angka memaksa
 *     orang menaksir dari tinggi — dan taksiran dari gambar selalu meleset ke
 *     arah yang menyenangkan pembacanya.
 */
import React from "react";

const rupiahPendek = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(1)} M`;
  if (v >= 1_000_000) return `${Math.round(v / 1_000_000)} jt`;
  if (v >= 1_000) return `${Math.round(v / 1_000)} rb`;
  return String(v);
};

function Batang({ data, nilai, warna, format }) {
  // ⛔ Butir 2 — puncaknya dari data, dasarnya SELALU nol.
  const maks = Math.max(1, ...data.map(nilai));
  return (
    <div className="flex items-end gap-2 overflow-x-auto pb-1" style={{ height: 160 }}>
      {data.map((d, i) => {
        const v = nilai(d);
        const tinggi = Math.round((v / maks) * 120);
        return (
          <div key={i} className="flex min-w-14 flex-1 flex-col items-center justify-end gap-1">
            {/* ⛔ Butir 3 — angkanya ditulis. */}
            <span className="whitespace-nowrap text-xs tabular-nums text-foreground">
              {format(v)}
            </span>
            <div className={`w-full rounded-t ${warna}`}
                 style={{ height: Math.max(v > 0 ? 3 : 1, tinggi) }} />
            <span className="whitespace-nowrap text-xs text-muted-foreground">
              {d.bulan.slice(5)}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default function GrafikOwner({ data }) {
  if (!data) return null;
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div className="rounded-xl border border-border bg-card p-4">
        <p className="text-sm font-medium text-foreground">Omzet per bulan</p>
        {/* ⚠ Sebabnya ditulis di layar, bukan cuma di kode: "omzet" yang
            dihitung dari nilai FA dan dari uang yang masuk adalah dua angka
            yang berbeda, dan yang membacanya berhak tahu yang mana. */}
        <p className="mb-3 text-xs text-muted-foreground">{data.catatan}</p>
        <Batang data={data.omzet} nilai={(d) => d.idr}
                warna="bg-success" format={rupiahPendek} />
      </div>

      <div className="rounded-xl border border-border bg-card p-4">
        <p className="text-sm font-medium text-foreground">Customer baru per bulan</p>
        <p className="mb-3 text-xs text-muted-foreground">
          Dihitung dari tanggal customer dibuat.
        </p>
        <Batang data={data.customer_baru} nilai={(d) => d.jumlah}
                warna="bg-info" format={(v) => String(v)} />
      </div>
    </div>
  );
}
